export default "__VITE_ASSET__01oRnrEq__"